/** */
import {
  ADD_MANY_SENTRIES_TO_STORE,
  ADD_ONE_SENTRY_TO_STORE,
  ADD_SEARCH_RESULTS_TO_STORE,
  LOAD_SENTRIES_TO_STORE,
  REM_ONE_SENTRY_FROM_STORE
} from '../actions/sentry';

export default (state = {}, action) => {
  const { type, payload } = action;
  let previous_state;
  switch (type) {
    case ADD_MANY_SENTRIES_TO_STORE:
      return {
        ...state,
        ...payload.reduce(
          (sentries, sentry) => ({
            ...sentries,
            [sentry.id]: sentry
          }),
          {}
        )
      };
    case ADD_ONE_SENTRY_TO_STORE:
      return {
        ...state,
        [payload.id]: payload
      };
    case ADD_SEARCH_RESULTS_TO_STORE:
      return {
        ...payload.reduce(
          (sentries, sentry) => ({
            ...sentries,
            [sentry.id]: sentry
          }),
          {}
        )
      };
    case LOAD_SENTRIES_TO_STORE:
      return {
        ...payload.reduce(
          (sentries, sentry) => ({
            ...sentries,
            [sentry.id]: sentry
          }),
          {}
        )
      };
    case REM_ONE_SENTRY_FROM_STORE:
      previous_state = { ...state };
      delete previous_state[payload];
      return {
        ...previous_state
      };
    default:
      return state;
  }
};
